export default "__VITE_ASSET__DvsJdMAI__"